import { Heading } from '@heathmont/moon-core';
import { rem } from 'polished';
import styled from 'styled-components';
import media from '~/client/shared/media';

const Title = styled(Heading)`
  && {
    margin-bottom: ${rem(12)};
    padding-right: ${rem(12)};
    ${media.tabletMedium} {
      margin-bottom: ${rem(24)};
      padding-right: 0;
    }
    strong {
      font-weight: ${({ theme }) => theme.fontWeight.semibold};
    }
  }
`;

export default Title;
